module.exports = __webpack_public_path__ + "img/prenatal.0f7997b8.png";